import { z } from 'zod'

export const commonSchema = z.object({
  asi: z.string().min(1),
  defaultSid: z.string().min(1),
  name: z.string().min(1),
})

export type CommonSchema = z.infer<typeof commonSchema>
